import Dashboard from "../pages/Dashboard";

export default function PortalDashboardPanel() {
  return (
    <div className="min-h-0 flex-1 bg-[hsl(var(--ds-bg))] text-[hsl(var(--ds-fg))]">
      <Dashboard />
    </div>
  );
}
